angular.module('wbServices').service 'sessionExpiryService', ['$rootScope', ($rootScope) ->

  sessionExpiry = null

  updateSession = _.debounce (expiresAt, expiresIn) =>
    sessionExpiry = {
      expiresAt: expiresAt,
      expiresIn: expiresIn,
    }
    $rootScope.$emit 'sessionExpiryUpdated', sessionExpiry
  , 1000

  @updateSession = (expiresAt, expiresIn) =>
    return unless expiresAt? and +expiresAt > 0 and expiresIn? and +expiresIn > 0
    updateSession(expiresAt, expiresIn)

  @getSessionExpiry = -> sessionExpiry

  @
]
.factory('sessionHttpInterceptor', ['sessionExpiryService',
(sessionExpiryService) ->

    return {
      response: (response) ->
        expiresAt = response.headers('X-WealthBar-Session-Expires-At')
        expiresIn = response.headers('X-WealthBar-Session-Expires-In')
        sessionExpiryService.updateSession(expiresAt, expiresIn)
        response
    }
])
